//@author: mandy

import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    ElementRef,
    Input,
    OnInit,
    ViewEncapsulation,
} from "@angular/core";
import { SpaceService } from "../../../services/space.service";
import { TypeManagerDecorator } from "../../../main/type.map.service";

@TypeManagerDecorator("s25-ng-bulk-location-edit-scheduler")
@Component({
    selector: "s25-ng-bulk-location-edit-scheduler",
    template: `
        <span class="c-margin-top--single c-margin-right--half ngInlineBlock ngBold">Add/Remove Scheduler</span>
        <s25-toggle-button
            (valueChange)="onToggleChange($event)"
            [value]="removeContact"
            [trueLabel]="trueLabel"
            [falseLabel]="falseLabel"
        ></s25-toggle-button>

        @if (!removeContact) {
            <div class="c-margin-top--single">
                <span class="ngBold">Select Scheduler</span>
                <s25-contact-dropdown
                    [(value)]="contact"
                    (valueChange)="addScheduler($event)"
                    [usersOnly]="true"
                    [ariaLabel]="'Select Scheduler'"
                />
            </div>
        }
        <s25-ng-bulk-edit-save
            [submitFn]="updateFn"
            [buttonText]="removeContact ? 'Remove Scheduler' : 'Add Scheduler'"
        ></s25-ng-bulk-edit-save>
    `,
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class S25BulkLocationEditSchedulerComponent implements OnInit {
    @Input() itemTypeId: any = undefined;
    @Input() locationIds: any = undefined;
    @Input() falseLabel: string = "Add";
    @Input() trueLabel: string = "Remove";

    contact: any = "";
    removeContact: boolean = false;

    constructor(
        private elementRef: ElementRef,
        private cd: ChangeDetectorRef,
    ) {
        this.elementRef.nativeElement.angBridge = this; //bridge to AngularJS; used for AngJS to set model values and call setter fns
    }

    ngOnInit() {
        this.cd.detectChanges();
    }

    onToggleChange(event: any) {
        this.removeContact = event;
        this.removeContact ? (this.contact = "") : "";
        this.cd.detectChanges();
    }

    addScheduler(c: any) {
        this.contact = c;
    }

    get updateFn() {
        return this.update.bind(this);
    }

    update() {
        if (this.contact === "" && !this.removeContact) {
            alert("Please select a scheduler.");
        } else {
            !this.removeContact ? (this.contact = this.contact.val) : "";
            return SpaceService.updateScheduler(this.locationIds, this.contact);
        }
    }
}
